export const colorSchemes = ["system", "light", "dark"];
export const colorSchemeLabels = {
    system: "Auto",
    light: "Hell",
    dark: "Dunkel",
    aria: "Farbschema",
};
//# sourceMappingURL=color-scheme.js.map